const constants = {
    UNAUTHORIZED: 'UNAUTHORIZED',
    LOGGED:    "LOGGED"    // The user is logged
};

export default constants;
